import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    /** ----------- 타행이체신청 (VTN,CBD 제외) -------------------*/
    //타행이체정보
    otrbnkTrsaccInfo: {
      //출금계좌정보
      drwotInfo: {
        // acno: "", //출금계좌번호
        // acnoAls: "", //출금계좌별명
        // cncycd: "", //출금통화코드
        // drwotAbilAmt: 0, //출금가능금액
        // dailyTrsaccAcamtRmainLimt: 0, //1일이체잔여한도
        pwdUuid: "", //비밀번호uuid
        _nprotected: "", //가상키패드
      },
      //입금계좌정보
      mnrcvInfo: {
        mnrcvAmt: 0, //입금금액
        fxTranzAmt: 0, //출금예정금액
        mnrcvAcno: "", //입금계좌번호
        mnrcvAcnAls: "", //입금계좌별명
        mnrcvCncycd: "", //입금통화코드
        mnrcvOthrBnkName: "", //수취 은행
        mnrcvBrnName: "", //MMR 지점이름
        rmtancObjctvDsticList: "", //MMR 송금목적
        receiverCode: "", //AUC code
        referenceMsg: "", //AUC reference
        rcevnBnkIfscCode: "", //IND IFSC 코드
        mnrcvDpstrName: "", //예금주명
        drwotRmark: "", //송금메모
        mnrcvRmark: "", //수취인통장표시내용
        selectedTab: "", //선택된 탭
        mnrcvSerno: "",
        acnoIndex: "", //자주쓰는 계좌 index 저장
        distinctAcno: "", //최근이체계좌 저장 필드
      },
    },

    //이체예비거래
    otrbnkTrasaccInptPro1: {},
    //이체본거래
    otrbnkTrasaccInptPro2: {},

    /** ----------- 타행이체신청 (VTN,CBD 제외) 끝 -------------------*/

    /** ----------- NAPAS 타행이체신청 (VTN) -------------------*/
    //타행이체정보
    napasTrsaccInfo: {
      //출금계좌정보
      drwotInfo: {
        sendCardAcc: "", // 송금카드계좌구분

        // 출금정보
        drwotCardNo: "", // 출금카드번호
        drwotAcno: "", // 출금계좌번호
        drwotAcnAls: "", // 출금계좌별명
        drwotBrnName: "", // 출금부점명
        drwotCncycd: "", // 출금통화코드
        drwotSerno: "", // 출금계좌일련번호
        drwotDpstrName: "", // 출금계좌예금주명
        drwotDpstrAddr: "", // 송금인주소
        drwotEcrypPwd: "", // 출금비밀번호
        drwotTrsaccMemo: "", // 송금메모

        fxTranzAmt: 0, // 환전금액
        anticiDrwotAmt: 0, // 예상출금금액
        anticiAplyExrt: 0, // 예상적용환율
        anticiAplyExrtCd: "", // 예상적용환율코드
        anticiFee: 0, // 예상수수료

        // 출금 기타정보
        drwotAbilAmt: 0, //출금가능금액
        dailyTrsaccAcamtRmainLimt: 0, //1일이체잔여한도

        pwdUuid: "", //비밀번호uuid
        _nprotected: "", //가상키패드
      },

      //입금계좌정보
      mnrcvInfo: {
        mainTranYn: "", // 본거래여부
        selectedTab: 0,

        // 입금정보
        recvCardAcc: "", // 수취카드계좌구분
        mnrcvCardNo: "", // 입금카드번호
        mnrcvAcno: "", // 입금계좌번호
        mnrcvAcnAls: "", // 입금계좌별명
        rcevnBnkNo: "", // 입금타은행번호
        mnrcvOthrBnkName: "", // 입금타은행명
        mnrcvBrnName: "", // 입금부점명
        mnrcvCncycd: "", // 입금통화코드
        mnrcvSerno: "", // 입금계좌일련번호
        mnrcvDpstrName: "", // 입금계좌예금주명
        mnrcvTrsaccAmt: 0, // 입금거래금액
        mnrcvDraweRefCtnt: "", // 입금수취인참조내용
        bnkName: "",
        bnkNo: "",
        tranDstCd: "", // 이체구분코드 0 :napas 1:citad
      },
    },

    //Napas수취인조회
    RBF04INA40: {
      in: {
        sendCardAcc: "", //송금카드계좌구분
        drwotCardNo: "", //출금카드번호
        drwotAcno: "", //출금계좌번호
        drwotCncycd: "", //출금통화코드
        drwotSerno: "", //출금계좌일련번호
        recvCardAcc: "", //수취카드계좌구분
        mnrcvCardNo: "", //입금카드번호
        mnrcvAcno: "", //입금계좌번호
        rcevnBnkNo: "", //입금타은행번호
        mnrcvOthrBnkName: "", //입금타은행명
        mnrcvCncycd: "", //입금통화코드
      },
      out: {},
    },

    //Napas카드번호조회
    RBF04INA41: {
      in: {
        cardNo: "", // 카드번호
        acno: "", // 계좌번호
        custIdnfr: "", // 고객식별자
        custMgtNo: "", // 고객관리번호
      },
      out: {},
    },

    //napas이체예비거래
    napasTrasaccInptPro1: {},
    //napas이체본거래
    napasTrasaccInptPro2: {},

    /** ----------- NAPAS 타행이체신청 (VTN) 끝 -------------------*/
  };
};

const otrbnkTrsaccInfoInpt = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    //이체정보
    getOtrbnkTrasaccInfo: state => {
      return state.otrbnkTrsaccInfo;
    },
    //출금정보
    getOtrbnkTrsaccDrwotInfo: state => {
      return state.otrbnkTrsaccInfo.drwotInfo;
    },
    //입금정보
    getOtrbnkTrsaccMnrcvInfo: state => {
      return state.otrbnkTrsaccInfo.mnrcvInfo;
    },

    /** NAPAS */
    //이체정보
    getNapasTrasaccInfo: state => {
      return state.napasTrsaccInfo;
    },
    //출금정보
    getNapasTrsaccDrwotInfo: state => {
      return state.napasTrsaccInfo.drwotInfo;
    },
    //입금정보
    getNapasTrsaccMnrcvInfo: state => {
      return state.napasTrsaccInfo.mnrcvInfo;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    //이체정보 초기화
    setOtrbnkTrsaccInfo_init: state => {
      state.otrbnkTrsaccInfo = getDefaultState().otrbnkTrsaccInfo;
    },
    //입금계좌정보(임시) 초기화
    setMnrcvInfo_init: state => {
      state.otrbnkTrsaccInfo.mnrcvInfo = getDefaultState().otrbnkTrsaccInfo.mnrcvInfo;
    },
    //이체정보
    setOtrbnkTrsaccInfo: (state, payload) => {
      state.otrbnkTrsaccInfo = payload;
    },
    // 입금계좌 설정
    setMnrcvOtrbnkTrsaccInfo: (state, payload) => {
      state.otrbnkTrsaccInfo.mnrcvInfo = payload;
    },
    /** NAPAS */
    //이체정보 초기화
    setNapasTrsaccInfo_init: state => {
      state.napasTrsaccInfo = getDefaultState().napasTrsaccInfo;
    },
    //입금계좌정보(임시) 초기화
    setNapasMnrcvInfo_init: state => {
      state.napasTrsaccInfo.mnrcvInfo = getDefaultState().napasTrsaccInfo.mnrcvInfo;
    },
    //이체정보
    setNapasTrsaccInfo: (state, payload) => {
      state.napasTrsaccInfo = payload;
    },
    // 입금계좌 설정
    setMnrcvNapasTrsaccInfo: (state, payload) => {
      state.napasTrsaccInfo.mnrcvInfo = payload;
    },
  },
  actions: {
    //이체정보 초기화
    ACT_setOtrbnkTrsaccInfo_init: context => {
      context.commit("setOtrbnkTrsaccInfo_init");
    },
    //입금계좌정보(임시) 초기화
    ACT_setMnrcvInfo_init: context => {
      context.commit("setMnrcvInfo_init");
    },
    //이체정보
    ACT_setOtrbnkTrsaccInfo: (context, payload) => {
      context.commit("setOtrbnkTrsaccInfo", payload);
    },
    //입금계좌 설정
    ACT_setMnrcvOtrbnkTrsaccInfo: (context, payload) => {
      context.commit("setMnrcvOtrbnkTrsaccInfo", payload);
    },

    /** NAPAS */
    //이체정보 초기화
    ACT_setNapasTrsaccInfo_init: context => {
      context.commit("setNapasTrsaccInfo_init");
    },
    //입금계좌정보(임시) 초기화
    ACT_setNapasMnrcvInfo_init: context => {
      context.commit("setNapasMnrcvInfo_init");
    },
    //이체정보
    ACT_setNapasTrsaccInfo: (context, payload) => {
      context.commit("setNapasTrsaccInfo", payload);
    },
    //입금계좌 설정
    ACT_setMnrcvNapasTrsaccInfo: (context, payload) => {
      context.commit("setMnrcvNapasTrsaccInfo", payload);
    },
    // RBF04INA40 - Napas수취인조회
    RBF04INA40Call: function(context) {
      return new Promise(resolve => {
        this._vm.$post("/transfer/otrbnk/NapasDraweNameInquiry", context.state.RBF04INA40.in, response => {
          context.state.RBF04INA40.out = response.outItem;
          resolve(response.outItem);
        });
      });
    },
    // RBF04INA41 - Napas 카드번호조회
    RBF04INA41Call: function(context) {
      return new Promise(resolve => {
        this._vm.$post("/transfer/otrbnk/NapasCardNoInquiry", context.state.RBF04INA41.in, response => {
          context.state.RBF04INA41.out = response.outItem;
          resolve(response.outItem);
        });
      });
    },
  },
};

export default otrbnkTrsaccInfoInpt;
